export default {
  /*
    ...
    */
  trello_authorized: state => state.trello.authorized,

  trello_auth_date: state => state.trello.auth_date,

}
